import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 11l8 3l8 -3","key":"svg-0"}]]

const IconChevronCompactDown = createReactComponent('outline', 'chevron-compact-down', 'ChevronCompactDown', __iconNode);

export default IconChevronCompactDown;